import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Heading } from "../../internal/Heading/Heading";
import * as styles from "./SectionTitle.styles";
export var SectionTitle = function SectionTitle(_ref) {
  var headingIsPageTitle = _ref.headingIsPageTitle,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledHeading, {
    level: headingIsPageTitle ? 1 : 2,
    $_css2: styles.title
  }, title));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledHeading = /*#__PURE__*/_styled2(Heading).withConfig({
  displayName: "SectionTitle___StyledHeading",
  componentId: "sc-a8328l-0"
})(["", ""], function (p) {
  return p.$_css2;
});